
(function(template){
  define('vue!optionalClassProgram/components/eventDetailComponent',[
    "Vue",
    "helpers",
    "vuex",
    "moment"

  ], function (
    Vue,
    helpers,
    vuex,
    moment
  ) {
    return {
      template: template,
      name: "",
      props: ['customerID'],
      data: function () {
        return {}
      },
      computed: _.extend(
        vuex.mapState(['currentlyBookingClassProgram','users']), {
            programDetails: function(){
                var details = this.currentlyBookingClassProgram
                var eventTime = moment(details.StartTime, "YYYY-MM-DDHHmmss").format("hh:mm a"),
                    eventDate = moment(details.StartTime, "YYYY-MM-DDHHmmss").format("dddd, MMMM Do, YYYY")
                details.eventDate = eventDate
                details.eventTime = eventTime
            return details;
            },
            eventDetailsPerUser: function(){
              var user  = this.users[this.customerID]
              return {eventPrice:user.eventPrice,eventName:user.eventName}
            },
            programTotalCost: function(){
              // will add event price based on a event this user chose
              var self = this;
              var components = app.data.eventPrograms[this.currentlyBookingClassProgram.SpaClassId]
              components = _.sortBy(components,function(x){return x.SortOrder})
              var sum = _.chain(components)
              .filter(function(cls) {return cls.OptionalComponent !="Y"})
              .reduce(function(memo, cls){ return memo + Number(cls.Price); }, 0)
              .value();
              return (sum+ Number(self.eventDetailsPerUser.eventPrice)).toFixed(2)
            } 
        }),
      components: {},
      methods: {
        
      },
    }
  })
})('<div> <div class="optional-class-event-details"> <div class="optional-class-event-details-left"> <p> <label for="">{{localStrings.ageRestriction.optionalClass.Location}}: </label><strong>{{programDetails.locationName}}</strong></p> <p> <label for="">{{localStrings.ageRestriction.optionalClass.event}}: </label><strong>{{eventDetailsPerUser.eventName}}</strong></p> <p> <label for="">{{localStrings.ageRestriction.optionalClass.startDate}}: </label><strong>{{programDetails.eventDate}}</strong></p> <p> <label for="">{{localStrings.ageRestriction.optionalClass.time}}: </label><strong>{{programDetails.eventTime}}</strong></p> <!-- <p> <label for="">Number of Classes: </label><strong>{{programDetails.NumClasses}}</strong></p> --> </div> <div class="optional-class-event-details-right"> <!-- <p> <label for="">Price: </label><strong>${{programDetails.Price}} per class</strong></p> --> <p> <label for="">{{localStrings.ageRestriction.optionalClass.programCost}}: </label><strong>${{programTotalCost}}</strong></p> </div> </div> <p class="program-classes-info-text"><strong>{{localStrings.ageRestriction.optionalClass.mandatoryClassMessage}}</strong></p> </div>');
